import React from 'react';
import { CheckmarkCircle } from 'components/Icon/CheckmarkCircle';
import styles from './styles.module.scss';

/** @import { Interests } from './'; */

/**
 * UI for selecting user interests
 * @param {object} props
 * @param {Interests} props.available
 * @param {string[]} props.value
 * @param {(newValue: string[]) => void} props.onChange
 */
export function InterestsSelector({ available, value, onChange }) {
  /**
   * @param {string} taxonomyId
   */
  function handleToggle(taxonomyId) {
    if (value.includes(taxonomyId)) {
      onChange(value.filter((id) => id !== taxonomyId));
    } else {
      onChange([...value, taxonomyId]);
    }
  }

  return (
    <div>
      {available.map((category) => (
        <div key={category.sectionTitle} role="group" aria-labelledby={category.sectionTitle}>
          <h2>{category.sectionTitle}</h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
            {category.sectionItems.map((item) => {
              const isSelected = value.includes(item.taxonomyTerm);

              return (
                <button
                  type="button"
                  aria-pressed={isSelected}
                  key={item.taxonomyTerm}
                  onClick={() => handleToggle(item.taxonomyTerm)}
                  className={styles.interestToggle}
                  style={{ backgroundImage: `url(${item.imageUrl})` }}
                >
                  <p>{item.title}</p>
                  <CheckmarkCircle />
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
